<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent" :class="{finished: finished}">
        <div class="close" v-on:click="close"></div>
        <div class="canvasRealCnt" v-if="!finished">
          <canvas ref="canvasOk1b" class="canvasReal"></canvas>
          <canvas ref="canvasOk2b" class="canvasReal"></canvas>
          <canvas ref="canvasOk3b" class="canvasReal"></canvas>
          <canvas ref="canvasOk4b" class="canvasReal"></canvas>
        </div>
        <div class="pictBlinker" v-if="pictBlinker"
          :class="{closeed: pictBlinkerClose}"></div>
        <div class="pictOk pict1Ok" v-if="pictOk.p1" :class="{okur: pictOk.a1}">
          <div class="cameraCnt">
            <canvas ref="canvasOk1" class="canvasFake"></canvas>
            <div class="bgOverlay" :class="bg">
              <div class="brandOverlay"></div>
            </div>
            <div class="nameOverlay">
              <div class="point">{{point}}</div>
              <div class="avatar" v-if="avatar"
                :style="{'background-image': `url(${avatar})`}"></div>
              <div class="avatar" v-else>
                <span v-if="name">{{name.substr(0, 2).toUpperCase()}}</span>
              </div>
              <h4>{{name}}</h4>
            </div>
            <div class="charOverlay" :class="[selectedChar, bmiType]">
              <div class="headCnt" :class="accTop">
                <div class="head default1"></div>
                <div class="head default2"></div>
                <div class="head badut"></div>
                <div class="head indo"></div>
                <div class="head gym"></div>
                <div class="head sekolah"></div>
                <div class="head farmer"></div>
                <div class="head gym2"></div>
                <div class="head lab"></div>
                <div class="head bodykey"></div>
                <div class="head indo2"></div>
                <div class="head paskib"></div>
                <div class="head hero"></div>
                <div class="head ai30"></div>
                <div class="head astro"></div>
              </div>
              <div class="faceCnt" :class="accMid">
                <div class="face default1"></div>
                <div class="face default2"></div>
                <div class="face badut"></div>
                <div class="face indo"></div>
                <div class="face gym"></div>
                <div class="face sekolah"></div>
                <div class="face farmer"></div>
                <div class="face gym2"></div>
                <div class="face lab"></div>
                <div class="face bodykey"></div>
                <div class="face indo2"></div>
                <div class="face paskib"></div>
                <div class="face hero"></div>
                <div class="face ai30"></div>
                <div class="face astro"></div>
              </div>
              <div class="bodyCnt" :class="accBot">
                <div class="body default1"></div>
                <div class="body default2"></div>
                <div class="body badut"></div>
                <div class="body indo"></div>
                <div class="body gym"></div>
                <div class="body sekolah"></div>
                <div class="body farmer"></div>
                <div class="body gym2"></div>
                <div class="body lab"></div>
                <div class="body bodykey"></div>
                <div class="body indo2"></div>
                <div class="body paskib"></div>
                <div class="body hero"></div>
                <div class="body ai30"></div>
                <div class="body astro"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pictOk pict2Ok" v-if="pictOk.p2" :class="{okur: pictOk.a2}">
          <div class="cameraCnt">
            <canvas ref="canvasOk2" class="canvasFake"></canvas>
            <div class="bgOverlay" :class="bg">
              <div class="brandOverlay"></div>
            </div>
            <div class="nameOverlay">
              <div class="point">{{point}}</div>
              <div class="avatar" v-if="avatar"
                :style="{'background-image': `url(${avatar})`}"></div>
              <div class="avatar" v-else>
                <span v-if="name">{{name.substr(0, 2).toUpperCase()}}</span>
              </div>
              <h4>{{name}}</h4>
            </div>
            <div class="charOverlay" :class="[selectedChar, bmiType]">
              <div class="headCnt" :class="accTop">
                <div class="head default1"></div>
                <div class="head default2"></div>
                <div class="head badut"></div>
                <div class="head indo"></div>
                <div class="head gym"></div>
                <div class="head sekolah"></div>
                <div class="head farmer"></div>
                <div class="head gym2"></div>
                <div class="head lab"></div>
                <div class="head bodykey"></div>
                <div class="head indo2"></div>
                <div class="head paskib"></div>
                <div class="head hero"></div>
                <div class="head ai30"></div>
                <div class="head astro"></div>
              </div>
              <div class="faceCnt" :class="accMid">
                <div class="face default1"></div>
                <div class="face default2"></div>
                <div class="face badut"></div>
                <div class="face indo"></div>
                <div class="face gym"></div>
                <div class="face sekolah"></div>
                <div class="face farmer"></div>
                <div class="face gym2"></div>
                <div class="face lab"></div>
                <div class="face bodykey"></div>
                <div class="face indo2"></div>
                <div class="face paskib"></div>
                <div class="face hero"></div>
                <div class="face ai30"></div>
                <div class="face astro"></div>
              </div>
              <div class="bodyCnt" :class="accBot">
                <div class="body default1"></div>
                <div class="body default2"></div>
                <div class="body badut"></div>
                <div class="body indo"></div>
                <div class="body gym"></div>
                <div class="body sekolah"></div>
                <div class="body farmer"></div>
                <div class="body gym2"></div>
                <div class="body lab"></div>
                <div class="body bodykey"></div>
                <div class="body indo2"></div>
                <div class="body paskib"></div>
                <div class="body hero"></div>
                <div class="body ai30"></div>
                <div class="body astro"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pictOk pict3Ok" v-if="pictOk.p3" :class="{okur: pictOk.a3}">
          <div class="cameraCnt">
            <canvas ref="canvasOk3" class="canvasFake"></canvas>
            <div class="bgOverlay" :class="bg">
              <div class="brandOverlay"></div>
            </div>
            <div class="nameOverlay">
              <div class="point">{{point}}</div>
              <div class="avatar" v-if="avatar"
                :style="{'background-image': `url(${avatar})`}"></div>
              <div class="avatar" v-else>
                <span v-if="name">{{name.substr(0, 2).toUpperCase()}}</span>
              </div>
              <h4>{{name}}</h4>
            </div>
            <div class="charOverlay" :class="[selectedChar, bmiType]">
              <div class="headCnt" :class="accTop">
                <div class="head default1"></div>
                <div class="head default2"></div>
                <div class="head badut"></div>
                <div class="head indo"></div>
                <div class="head gym"></div>
                <div class="head sekolah"></div>
                <div class="head farmer"></div>
                <div class="head gym2"></div>
                <div class="head lab"></div>
                <div class="head bodykey"></div>
                <div class="head indo2"></div>
                <div class="head paskib"></div>
                <div class="head hero"></div>
                <div class="head ai30"></div>
                <div class="head astro"></div>
              </div>
              <div class="faceCnt" :class="accMid">
                <div class="face default1"></div>
                <div class="face default2"></div>
                <div class="face badut"></div>
                <div class="face indo"></div>
                <div class="face gym"></div>
                <div class="face sekolah"></div>
                <div class="face farmer"></div>
                <div class="face gym2"></div>
                <div class="face lab"></div>
                <div class="face bodykey"></div>
                <div class="face indo2"></div>
                <div class="face paskib"></div>
                <div class="face hero"></div>
                <div class="face ai30"></div>
                <div class="face astro"></div>
              </div>
              <div class="bodyCnt" :class="accBot">
                <div class="body default1"></div>
                <div class="body default2"></div>
                <div class="body badut"></div>
                <div class="body indo"></div>
                <div class="body gym"></div>
                <div class="body sekolah"></div>
                <div class="body farmer"></div>
                <div class="body gym2"></div>
                <div class="body lab"></div>
                <div class="body bodykey"></div>
                <div class="body indo2"></div>
                <div class="body paskib"></div>
                <div class="body hero"></div>
                <div class="body ai30"></div>
                <div class="body astro"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pictOk pict4Ok" v-if="pictOk.p4" :class="{okur: pictOk.a4}">
          <div class="cameraCnt">
            <canvas ref="canvasOk4" class="canvasFake" v-if="!finished"></canvas>
            <div class="bgOverlay" :class="bg">
              <div class="brandOverlay"></div>
            </div>
            <div class="nameOverlay">
              <div class="point">{{point}}</div>
              <div class="avatar" v-if="avatar"
                :style="{'background-image': `url(${avatar})`}"></div>
              <div class="avatar" v-else>
                <span v-if="name">{{name.substr(0, 2).toUpperCase()}}</span>
              </div>
              <h4>{{name}}</h4>
            </div>
            <div class="charOverlay" :class="[selectedChar, bmiType]">
              <div class="headCnt" :class="accTop">
                <div class="head default1"></div>
                <div class="head default2"></div>
                <div class="head badut"></div>
                <div class="head indo"></div>
                <div class="head gym"></div>
                <div class="head sekolah"></div>
                <div class="head farmer"></div>
                <div class="head gym2"></div>
                <div class="head lab"></div>
                <div class="head bodykey"></div>
                <div class="head indo2"></div>
                <div class="head paskib"></div>
                <div class="head hero"></div>
                <div class="head ai30"></div>
                <div class="head astro"></div>
              </div>
              <div class="faceCnt" :class="accMid">
                <div class="face default1"></div>
                <div class="face default2"></div>
                <div class="face badut"></div>
                <div class="face indo"></div>
                <div class="face gym"></div>
                <div class="face sekolah"></div>
                <div class="face farmer"></div>
                <div class="face gym2"></div>
                <div class="face lab"></div>
                <div class="face bodykey"></div>
                <div class="face indo2"></div>
                <div class="face paskib"></div>
                <div class="face hero"></div>
                <div class="face ai30"></div>
                <div class="face astro"></div>
              </div>
              <div class="bodyCnt" :class="accBot">
                <div class="body default1"></div>
                <div class="body default2"></div>
                <div class="body badut"></div>
                <div class="body indo"></div>
                <div class="body gym"></div>
                <div class="body sekolah"></div>
                <div class="body farmer"></div>
                <div class="body gym2"></div>
                <div class="body lab"></div>
                <div class="body bodykey"></div>
                <div class="body indo2"></div>
                <div class="body paskib"></div>
                <div class="body hero"></div>
                <div class="body ai30"></div>
                <div class="body astro"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="intro" v-if="intro">
          <div class="introIn">
            <h4>Buat GIF</h4>
            <p>Ambil 4 foto dengan 4 ekspresi yang berbeda, lalu akan
            di generate menjadi gif dengan latar belakang Nunu/Lili</p>
            <button v-on:click="intro = false;">Mulai</button>
          </div>
        </div>
        <div class="outro" v-if="outro">
          <img :src="imgUri">
          <div class="btnCnt">
            <a :href="imgUri" class="btn download"  target="_blank"
              download>Download GIF</a>
            <button class="btn share" v-on:click="finished = true; outro = false">Bagikan</button>
          </div>
        </div>
        <div class="finished" v-if="finished">
          <div class="bgCnt"><img :src="imgUri"></div>
          <h4>Bagikan melalui</h4>
          <p>Jangan lupa tambahkan hashtag
            <span>#BodyKeyChallenge2023</span> pada post
            Instagram atau Twitter kamu.</p>
          <div class="selectorCnt">
            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareEncoded}`"
              target="_blank" class="selectorItem">
              <img src="../assets/i-facebook-2.png">
              <h4>Post</h4>
            </a>
            <a :href="`https://twitter.com/intent/tweet?url=${shareEncoded}&text=${escapedTitle}&related=Amway,Boydkey,Nutrilite,BkChallenge2023`"
              target="_blank" class="selectorItem">
              <img src="../assets/i-twitter-2.png">
              <h4>Tweet</h4>
            </a>
            <a :href="`https://api.whatsapp.com/send/?phone&text=${waText}&app_absent=0`"
              target="_blank" class="selectorItem">
              <img src="../assets/i-wa.png">
              <h4>Send</h4>
            </a>
            <div class="selectorItem" v-on:click="openIg">
              <img src="../assets/i-instagram.png">
              <h4>Instagram</h4>
            </div>
            <a :href="`mailto:?subject=${escapedTitleOnly}&body=${emailBody}`"
              target="_blank" class="selectorItem">
              <img src="../assets/envelope-2.png">
              <h4>Email</h4>
            </a>
          </div>
          <div class="shareLink">
            {{shareUriDisplay}}
            <div class="copy" v-on:click="copyToClp(shareUriDisplay)">SALIN</div>
          </div>
          <div class="downloadCnt">
            <a :href="imgUri" class="download"  target="_blank"
              download>Download GIF</a>
          </div>
        </div>
        <div v-else>
          <div class="adjustLabel" v-if="!loading && !cameraUnsuported
            && !pictTaken && !intro && !outro">
            Sesuaikan posisi muka kamu dengan muka
            {{selectedChar}}
          </div>
          <div v-if="loading" class="loadingCnt" :class="{open: loadingOpen}">
            <div class="loadingLabel">
              <div class="loader"></div>
              <h4>Membuat GIF</h4>
              <p>Mohon tunggu, sedang membuat gambar karakter kamu.
              Jangan tutup browser kamu, ini mungkin akan memakan waktu beberapa saat.</p>
            </div>
          </div>
          <div v-if="cameraUnsuported" class="loadingCnt cameraUnsuported open">
            <div class="loadingLabel">
              <img src="../assets/no-camera.png">
              <h4>Perangkat Tidak Didukung</h4>
              <p>Tidak dapat mendeteksi kamera pada perangkat kamu.</p>
            </div>
          </div>
          <div class="cameraCnt" :class="{pictTaken: pictTaken}" id="cameraCnt">
            <video autoplay="true" id="video" muted playsinline v-if="!finished"></video>
            <!-- <video autoplay="true" id="video2" muted playsinline loop></video> -->
            <canvas id="canvas" v-if="!finished"></canvas>
            <div class="bgOverlay" :class="bg">
              <div class="brandOverlay"></div>
            </div>
            <div class="nameOverlay">
              <div class="point">{{point}}</div>
              <div class="avatar" v-if="avatar"
                :style="{'background-image': `url(${avatar})`}"></div>
              <div class="avatar" v-else>
                <span v-if="name">{{name.substr(0, 2).toUpperCase()}}</span>
              </div>
              <h4>{{name}}</h4>
            </div>
            <div class="charOverlay" :class="[selectedChar, bmiType]">
              <div class="headCnt" :class="accTop">
                <div class="head default1"></div>
                <div class="head default2"></div>
                <div class="head badut"></div>
                <div class="head indo"></div>
                <div class="head gym"></div>
                <div class="head sekolah"></div>
                <div class="head farmer"></div>
                <div class="head gym2"></div>
                <div class="head lab"></div>
                <div class="head bodykey"></div>
                <div class="head indo2"></div>
                <div class="head paskib"></div>
                <div class="head hero"></div>
                <div class="head ai30"></div>
                <div class="head astro"></div>
              </div>
              <div class="faceCnt" :class="accMid">
                <div class="face default1"></div>
                <div class="face default2"></div>
                <div class="face badut"></div>
                <div class="face indo"></div>
                <div class="face gym"></div>
                <div class="face sekolah"></div>
                <div class="face farmer"></div>
                <div class="face gym2"></div>
                <div class="face lab"></div>
                <div class="face bodykey"></div>
                <div class="face indo2"></div>
                <div class="face paskib"></div>
                <div class="face hero"></div>
                <div class="face ai30"></div>
                <div class="face astro"></div>
              </div>
              <div class="bodyCnt" :class="accBot">
                <div class="body default1"></div>
                <div class="body default2"></div>
                <div class="body badut"></div>
                <div class="body indo"></div>
                <div class="body gym"></div>
                <div class="body sekolah"></div>
                <div class="body farmer"></div>
                <div class="body gym2"></div>
                <div class="body lab"></div>
                <div class="body bodykey"></div>
                <div class="body indo2"></div>
                <div class="body paskib"></div>
                <div class="body hero"></div>
                <div class="body ai30"></div>
                <div class="body astro"></div>
              </div>
            </div>
            <div class="recording" v-if="isRecording">Recording</div>
            <div class="actionBtnCnt" v-else-if="!pictTaken">
              <div class="actionInfo">
                {{pictIdx}}/4 Photo
              </div>
              <div class="actionBtn takePicture" :class="{loading: !cameraStarted,
                pictCd: pictCd}"
                v-on:click="takePicture" v-if="2>1">
                <span class="pictCd" v-if="pictCd">{{pictCd}}</span>
              </div>
              <div class="actionBtn takeVideo" :class="{loading: !cameraStarted}"
                v-on:click="takeVideo" v-else></div>
            </div>
            <div class="actionBtnCnt" v-else>
              <div class="actionBtn secondary"
                v-on:click="changePhoto">Ulangi</div>
              <div class="actionBtn" v-on:click="downloadImage">
                Buat GIF</div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar ref="snackbar"/>
      <IgDialog ref="igDialog"/>
    </div>
  </transition>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';
import IgDialog from '@/components/IgDialog.vue';

export default {
  name: 'selfie',
  components: { Snackbar, IgDialog },
  data() {
    return {
      show: false,
      next: null,
      loading: false,
      loadingOpen: false,
      finished: false,
      intro: true,
      outro: false,

      /**
       * Profile
       *
       */
      name: '',
      avatar: null,
      point: 0,

      /**
       * Character
       *
       */
      bg: 'bg1',
      selectedChar: 'nunu',
      bmiType: 'normal',
      accTop: 'none',
      accMid: 'none',
      accBot: 'none',

      /**
       * Share
       *
       */
      shareUriDisplay: '',
      escapedMedia: '',
      shareEncoded: '',
      escapedTitle: '',
      waText: '',
      emailBody: '',
      imgUri: '',

      /**
       * Camera
       *
       */
      videoUri: '',
      isRecording: false,
      mediaRecorder: null,
      cameraUnsuported: false,
      pictTaken: false,
      cameraStarted: false,
      ctx: null,
      pictCd: null,
      pictBlinker: false,
      pictBlinkerClose: false,
      pictIdx: 1,
      pictOk: {
        p1: false,
        a1: false,
        p2: false,
        a2: false,
        p3: false,
        a3: false,
        p4: false,
        a4: false,
      },
    };
  },
  methods: {
    open(d, next) {
      this.next = next;
      this.show = true;
      this.loading = false;
      this.finished = false;
      this.intro = true;
      this.outro = false;

      this.ctx = null;

      this.cameraUnsuported = false;
      this.pictTaken = false;
      this.cameraStarted = false;

      this.pictBlinker = false;
      this.pictBlinkerClose = false;
      this.pictCd = null;
      this.pictIdx = 1;
      this.pictOk.p1 = false;
      this.pictOk.a1 = false;
      this.pictOk.p2 = false;
      this.pictOk.a2 = false;
      this.pictOk.p3 = false;
      this.pictOk.a3 = false;
      this.pictOk.p4 = false;
      this.pictOk.a4 = false;

      this.name = this.$session.get('bk6_name');
      this.point = this.$session.get('bk6_point') || 0;
      this.avatar = this.$session.get('bk6_avatar');

      this.bg = this.$session.get('bk6_bg') || 'bg1';
      if (this.bg === 'custom') this.bg = 'bg1';
      this.selectedChar = this.$session.get('bk6_character') || 'nunu';
      this.bmiType = this.$session.get('bk6_bmiType') || 'normal';
      this.accTop = this.$session.get('bk6_accTop') || 'none';
      this.accMid = this.$session.get('bk6_accMid') || 'none';
      this.accBot = this.$session.get('bk6_accBot') || 'none';

      this.startCamera();
    },
    startCamera() {
      if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({
          video: {
            width: { min: 852, ideal: 1280, max: 1920 },
            height: { min: 480, ideal: 720, max: 1080 },
            facingMode: 'user',
          },
          audio: false,
        }).then((stream) => {
          video.srcObject = stream;
          setTimeout(() => {
            this.cameraStarted = true;
          }, 500);
        }).catch((err) => {});
      } else {
        this.cameraUnsuported = true;
      }
    },
    stopCamera() {
      if (typeof video === 'undefined' || !video) return;
      const stream = video.srcObject;
      if (!stream) return;
      const tracks = stream.getTracks();
      for (let i = 0; i < tracks.length; i += 1) {
        const track = tracks[i];
        track.stop();
      }
      video.srcObject = null;
    },
    takePicture() {
      if (!this.cameraStarted) return;
      this.pictCd = 3;
      setTimeout(() => {
        this.pictCd = 2;
        setTimeout(() => {
          this.pictCd = 1;
          setTimeout(() => {
            video.pause();
            this.pictCd = null;
            this.pictBlinker = true;
            this.pictBlinkerClose = false;
            this.pictOk[`p${this.pictIdx}`] = true;
            setTimeout(() => {
              /**
               * Draw to canvas
               *
               */
              this.$refs[`canvasOk${this.pictIdx}`].width = cameraCnt.offsetWidth;
              this.$refs[`canvasOk${this.pictIdx}`].height = cameraCnt.offsetHeight;
              const vs = this.calcAspectRatioFit(
                video.videoWidth,
                video.videoHeight,
                this.$refs[`canvasOk${this.pictIdx}`].width,
                this.$refs[`canvasOk${this.pictIdx}`].height,
              );
              const vsOff = { x: 0, y: 0 };
              if (vs.width / vs.height) {
                vsOff.x = 0;
                vsOff.y = (this.$refs[`canvasOk${this.pictIdx}`].height / 2) - (vs.height * 42 / 100);
              } else {
                vsOff.x = 0;
                vsOff.y = 0;
              }
              const ctx = this.$refs[`canvasOk${this.pictIdx}`].getContext('2d');
              ctx.drawImage(video, 0, 0, video.videoWidth,
                video.videoHeight, vsOff.x, vsOff.y, vs.width, vs.height);

              this.$refs[`canvasOk${this.pictIdx}b`].width = cameraCnt.offsetWidth;
              this.$refs[`canvasOk${this.pictIdx}b`].height = cameraCnt.offsetHeight;
              const vsb = this.calcAspectRatioFit(
                video.videoWidth,
                video.videoHeight,
                this.$refs[`canvasOk${this.pictIdx}b`].width,
                this.$refs[`canvasOk${this.pictIdx}b`].height,
              );
              const vsOffb = { x: 0, y: 0 };
              if (vsb.width / vsb.height) {
                vsOffb.x = 0;
                vsOffb.y = (this.$refs[`canvasOk${this.pictIdx}b`].height / 2) - (vsb.height * 42 / 100);
              } else {
                vsOffb.x = 0;
                vsOffb.y = 0;
              }
              const ctxb = this.$refs[`canvasOk${this.pictIdx}b`].getContext('2d');
              ctxb.drawImage(video, 0, 0, video.videoWidth,
                video.videoHeight, vsOffb.x, vsOffb.y, vsb.width, vsb.height);

              this.pictBlinkerClose = true;
              setTimeout(() => {
                video.play();
                this.pictBlinker = false;
                setTimeout(() => {
                  this.pictOk[`a${this.pictIdx}`] = true;
                  if (this.pictIdx >= 4) {
                    setTimeout(() => {
                      this.genGif();
                    }, 350);
                    return;
                  }
                  this.pictIdx += 1;
                });
              }, 600);
            });
          }, 1000);
        }, 1000);
      }, 1000);
    },
    genGif() {
      this.loading = true;
      setTimeout(() => {
        this.loadingOpen = true;
      }, 100);
      setTimeout(() => {
        this.$refs.canvasOk1b.toBlob((blob1) => {
          const formData1 = new FormData();
          formData1.append('file', blob1);
          formData1.append('i', 'img1');
          this.$http.post(this.$config.uri('user/gif/upload'), formData1, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent) => {
              // Display progress in chat
            },
          }).then((r) => {
            this.$refs.canvasOk2b.toBlob((blob2) => {
              const formData2 = new FormData();
              formData2.append('file', blob2);
              formData2.append('i', 'img2');
              formData2.append('id', r.data.id);
              this.$http.post(this.$config.uri('user/gif/upload'), formData2, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                  // Display progress in chat
                },
              }).then((r2) => {
                this.$refs.canvasOk3b.toBlob((blob3) => {
                  const formData3 = new FormData();
                  formData3.append('file', blob3);
                  formData3.append('i', 'img3');
                  formData3.append('id', r.data.id);
                  this.$http.post(this.$config.uri('user/gif/upload'), formData3, {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: (progressEvent) => {
                      // Display progress in chat
                    },
                  }).then((r3) => {
                    this.$refs.canvasOk4b.toBlob((blob4) => {
                      const formData4 = new FormData();
                      formData4.append('file', blob4);
                      formData4.append('i', 'img4');
                      formData4.append('id', r.data.id);
                      this.$http.post(this.$config.uri('user/gif/upload'), formData4, {
                        headers: {
                          'Content-Type': 'multipart/form-data',
                        },
                        onUploadProgress: (progressEvent) => {
                          // Display progress in chat
                        },
                      }).then((r4) => {
                        this.$http.get(this.$config.uri(`user/gif/${r.data.id}/generate`)).then((r5) => {
                          this.pictOk.p1 = false;
                          this.pictOk.a1 = false;
                          this.pictOk.p2 = false;
                          this.pictOk.a2 = false;
                          this.pictOk.p3 = false;
                          this.pictOk.a3 = false;
                          this.pictOk.p4 = false;
                          this.pictOk.a4 = false;
                          this.pictBlinker = false;
                          this.pictBlinkerClose = false;
                          this.pictCd = null;
                          this.pictIdx = 1;

                          this.shareUriDisplay = `${this.$config.cdnUri}gif/s6/${r5.data.uuid}`;
                          this.shareEncoded = escape(this.shareUriDisplay);
                          this.escapedTitle = escape('Karakter Saya selama mengikuti #BodyKeyChallenge2023');
                          this.waText = escape(`Lihat karakter Saya selama mengikuti #BodyKeyChallenge2023
                           di ${this.shareUriDisplay}`);
                          this.emailBody = escape(`Hi!\n\nLihat karakter Saya selama
                          mengikuti #BodyKeyChallenge2023 di ${this.shareUriDisplay}`);
                          this.escapedTitleOnly = escape('Karakter Saya Selama Mengikuti #BodyKeyChallenge2023');
                          this.imgUri = (r5.data.status === 200) ? r5.data.uri : '';
                          this.loading = false;
                          this.outro = true;
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      }, 1000);
    },
    changePhoto() {
      video.play();
      this.pictTaken = false;
    },
    calcAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
      const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
      return { width: srcWidth * ratio, height: srcHeight * ratio };
    },
    downloadImage() {
      this.loading = true;

      /**
       * Draw to canvas before upload
       *
       */
      canvas.width = cameraCnt.offsetWidth * 3;
      canvas.height = cameraCnt.offsetHeight * 3;
      const vs = this.calcAspectRatioFit(
        video.videoWidth,
        video.videoHeight,
        canvas.width,
        canvas.height,
      );
      const vsOff = { x: 0, y: 0 };
      if (vs.width / vs.height) {
        vsOff.x = 0;
        vsOff.y = (canvas.height / 2) - (vs.height * 42 / 100);
      } else {
        vsOff.x = 0;
        vsOff.y = 0;
      }
      if (!this.ctx) this.ctx = canvas.getContext('2d');
      this.ctx.drawImage(video, 0, 0, video.videoWidth,
        video.videoHeight, vsOff.x, vsOff.y, vs.width, vs.height);
      canvas.toBlob((blob) => {
        const formData = new FormData();
        formData.append('file', blob);
        this.$http.post(this.$config.uri('user/selfie/create'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            // Display progress in chat
          },
        }).then((r) => {
          this.shareUriDisplay = `${this.$config.cdnUri}gif/s6/${r.data.uuid}`;
          this.shareEncoded = escape(this.shareUriDisplay);
          this.escapedTitle = escape('Karakter Saya selama mengikuti #BodyKeyChallenge2023');
          this.waText = escape(`Lihat karakter Saya selama mengikuti #BodyKeyChallenge2023
           di ${this.shareUriDisplay}`);
          this.emailBody = escape(`Hi!\n\nLihat karakter Saya selama
          mengikuti #BodyKeyChallenge2023 di ${this.shareUriDisplay}`);
          this.escapedTitleOnly = escape('Karakter Saya Selama Mengikuti #BodyKeyChallenge2023');
          this.imgUri = (r.data.status === 200) ? r.data.uri : '';
          this.loading = false;
          this.finished = true;
        });
      });
    },
    openIg() {
      this.$refs.igDialog.open();
    },
    copyToClp(txt2copy) {
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Link copied to clipboard.' });
    },
    takeVideo() {
      if (this.isRecording) {
        this.isRecording = false;
        this.mediaRecorder.stop();
        return;
      }
      this.isRecording = true;
      this.mediaRecorder = new MediaRecorder(video.srcObject, { mimeType: 'video/webm' });
      const blobsRecorded = [];
      this.mediaRecorder.addEventListener('dataavailable', (e) => {
        blobsRecorded.push(e.data);
      });
      this.mediaRecorder.addEventListener('stop', () => {
        const videoLocal = URL.createObjectURL(new Blob(blobsRecorded, { type: 'video/webm' }));
        this.videoUri = videoLocal;
        const source = document.createElement('source');
        source.setAttribute('src', this.videoUri);
        source.setAttribute('type', 'video/webm');
        video2.appendChild(source);
        video2.play();
      });
      this.mediaRecorder.start();
      setTimeout(() => {
        this.stopVideo();
      }, 3000);
    },
    stopVideo() {
      this.pictTaken = true;
      this.isRecording = false;
      this.mediaRecorder.stop();
    },
    close(b) {
      this.stopCamera();
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
  },
};
</script>

<style scoped lang="scss">
.cameraCnt{
  position: relative;
  overflow: hidden;
  height: 600px;
  video{
    display: block;
    width: 100%;
    height: auto;
    background-color: #000;
    transform: translateY(-42%) scaleX(-1); // Mirror camera
    position: absolute;
    left: 0; top: 50%;
    z-index: 2;
  }
  #video2{
    z-index: 1;
    display: none;
  }
  &.pictTaken #video2{
    z-index: 3;
  }
  canvas{
    position: absolute;
    left: 0; top: 0;
  }
  .bgOverlay{
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    background-image: url(../assets/bg/bg-1.png);
    background-size: cover;
    background-position: center;
    z-index: 4;
    .brandOverlay{
      z-index: 5;
      position: absolute;
      left: 50%; top: 40px;
      width: 200px; height: 200px;
      transform: translateX(-50%);
      background-image: url(../assets/logo-bg-1.png);
      background-size: 160px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    &.bg2{
      background-image: url(../assets/bg/bg-2.png);
      .brandOverlay{
        background-image: url(../assets/logo-bg-2.png);
      }
    }
    &.bg3{
      background-image: url(../assets/bg/bg-3.png);
      .brandOverlay{
        background-image: url(../assets/logo-bg-3.png);
      }
    }
    &.bg4{
      background-image: url(../assets/bg/bg-4.png);
      .brandOverlay{
        display: none;
      }
    }
  }
  .nameOverlay{
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    background-image: url(../assets/name-container.png);
    background-size: cover;
    background-position: center;
    z-index: 7;
    .point{
      position: absolute;
      left: 20px; top: 26px;
      text-align: center;
      width: 40px; height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #222;
    }
    .avatar{
      position: absolute;
      right: 21px; top: 17px;
      opacity: .6;
      width: 40px; height: 40px;
      border-radius: 50%;
      box-sizing: border-box;
      padding-top: 10px;
      text-align: center;
      background-size: cover;
      background-position: center;
      font-weight: bold;
      opacity: 1;
      color: #000;
    }
    h4{
      position: absolute;
      top: 20px; right: 70px;
      width: 170px; height: 34px;
      padding-top: 4px;
      box-sizing: border-box;
      margin: 0;
      font-size: 20px !important;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      color: #222;
      text-overflow: ellipsis;
    }
  }
  .charOverlay{
    position: absolute;
    left: -80px; right: -80px;
    bottom: 40px; height: 520px;
    text-align: center;
    z-index: 9;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(../assets/char-with-hole/nunu-normal-1.png);
    &.kurus{
      background-image: url(../assets/char-with-hole/nunu-kurus-1.png);
    }
    &.gemuk{
      background-image: url(../assets/char-with-hole/nunu-gemuk-1.png);
    }
    &.lili{
      background-image: url(../assets/char-with-hole/lili-normal-1.png);
      &.kurus{
        background-image: url(../assets/char-with-hole/lili-kurus-1.png);
      }
      &.gemuk{
        background-image: url(../assets/char-with-hole/lili-gemuk-1.png);
      }
    }
    .headCnt{
      .head{ visibility: hidden; }
      &.default1{
        .head.default1{ visibility: visible; }
      }
      &.default2{
        .head.default2{ visibility: visible; }
      }
      &.badut{
        .head.badut{ visibility: visible; }
      }
      &.indo{
        .head.indo{ visibility: visible; }
      }
      &.gym{
        .head.gym{ visibility: visible; }
      }
      &.sekolah{
        .head.sekolah{ visibility: visible; }
      }
      &.farmer{
        .head.farmer{ visibility: visible; }
      }
      &.gym2{
        .head.gym2{ visibility: visible; }
      }
      &.lab{
        .head.lab{ visibility: visible; }
      }
      &.bodykey{
        .head.bodykey{ visibility: visible; }
      }
      &.indo2{
        .head.indo2{ visibility: visible; }
      }
      &.paskib1{
        .head.paskib{ visibility: visible; }
      }
      &.hero1{
        .head.hero{ visibility: visible; }
      }
      &.AI30-1{
        .head.ai30{ visibility: visible; }
      }
      &.astro{
        .head.astro{ visibility: visible; }
      }
    }
    .head{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      &.default1{
        background-image: url(../assets/acc/acc-winter-atas-1.png);
      }
      &.default2{
        background-image: url(../assets/acc/acc-summer-atas-1.png);
      }
      &.badut{
        background-image: url(../assets/acc/acc-badut-atas-1.png);
      }
      &.indo{
        background-image: url(../assets/acc/acc-indo-atas-1.png);
      }
      &.gym{
        background-image: url(../assets/acc/acc-gym-atas-1.png);
      }
      &.sekolah{
        background-image: url(../assets/acc/acc-sekolah-atas-1.png);
      }
      &.farmer{
        background-image: url(../assets/acc/acc-petani-atas-1.png);
      }
      &.lab{
        background-image: url(../assets/acc/acc-lab-atas-1.png);
      }
      &.gym2{
        background-image: url(../assets/acc/acc-gym2-atas-1.png);
      }
      &.bodykey{
        background-image: url(../assets/acc/acc-bk-atas-1.png);
      }
      &.indo2{
        background-image: url(../assets/acc/acc-indo2-1-atas.png);
      }
      &.paskib{
        background-image: url(../assets/acc/acc-paskib-1-atas.png);
      }
      &.hero{
        background-image: url(../assets/acc/acc-pahlawan-1-atas.png);
      }
      &.ai30{
        background-image: url(../assets/acc/acc-AI30-1-atas.png);
      }
      &.astro{
        background-image: url(../assets/acc/acc-astro-1.png);
      }
    }
    .faceCnt{
      .face{ visibility: hidden; }
      &.default1{
        .face.default1{ visibility: visible; }
      }
      &.default2{
        .face.default2{ visibility: visible; }
      }
      &.badut{
        .face.badut{ visibility: visible; }
      }
      &.indo{
        .face.indo{ visibility: visible; }
      }
      &.gym{
        .face.gym{ visibility: visible; }
      }
      &.sekolah{
        .face.sekolah{ visibility: visible; }
      }
      &.farmer{
        .face.farmer{ visibility: visible; }
      }
      &.lab{
        .face.lab{ visibility: visible; }
      }
      &.gym2{
        .face.gym2{ visibility: visible; }
      }
      &.bodykey{
        .face.bodykey{ visibility: visible; }
      }
      &.indo2{
        .face.indo2{ visibility: visible; }
      }
      &.paskib1{
        .face.paskib{ visibility: visible; }
      }
      &.hero1{
        .face.hero{ visibility: visible; }
      }
      &.AI30-1{
        .face.ai30{ visibility: visible; }
      }
      &.astro{
        .face.astro{ visibility: visible; }
      }
    }
    .face{
      left: 0; right: 0; top: 0; bottom: 0;
      position: absolute;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      &.default1{
        background-image: url(../assets/acc/acc-winter-tengah-1.png);
      }
      &.default2{
        background-image: url(../assets/acc/acc-summer-tengah-1.png);
      }
      &.badut{
        background-image: url(../assets/acc/acc-badut-tengah-1.png);
      }
      &.indo{
        background-image: url(../assets/acc/acc-indo-tengah-1.png);
      }
      &.gym{
        background-image: url(../assets/acc/acc-gym-tengah-1.png);
      }
      &.sekolah{
        background-image: url(../assets/acc/acc-sekolah-tengah-1.png);
      }
      &.farmer{
        background-image: url(../assets/acc/acc-petani-tengah-1.png);
      }
      &.gym2{
        background-image: url(../assets/acc/acc-gym2-tengah-1.png);
      }
      &.lab{
        background-image: url(../assets/acc/acc-lab-tengah-1.png);
      }
      &.bodykey{
        background-image: url(../assets/acc/acc-bk-tengah-1.png);
      }
      &.indo2{
        background-image: url(../assets/acc/acc-indo2-1-tengah.png);
      }
      &.paskib{
        background-image: url(../assets/acc/acc-paskib-1-tengah.png);
      }
      &.hero{
        background-image: url(../assets/acc/acc-pahlawan-1-tengah.png);
      }
      &.ai30{
        background-image: url(../assets/acc/acc-AI30-1-tengah.png);
      }
      &.astro{
        background-image: url(../assets/acc/acc-astro-1.png);
      }
    }
    .bodyCnt{
      .body{ visibility: hidden; }
      &.default1{
        .body.default1{ visibility: visible; }
      }
      &.default2{
        .body.default2{ visibility: visible; }
      }
      &.badut{
        .body.badut{ visibility: visible; }
      }
      &.indo{
        .body.indo{ visibility: visible; }
      }
      &.gym{
        .body.gym{ visibility: visible; }
      }
      &.sekolah{
        .body.sekolah{ visibility: visible; }
      }
      &.farmer{
        .body.farmer{ visibility: visible; }
      }
      &.lab{
        .body.lab{ visibility: visible; }
      }
      &.gym2{
        .body.gym2{ visibility: visible; }
      }
      &.bodykey{
        .body.bodykey{ visibility: visible; }
      }
      &.indo2{
        .body.indo2{ visibility: visible; }
      }
      &.paskib1{
        .body.paskib{ visibility: visible; }
      }
      &.hero1{
        .body.hero{ visibility: visible; }
      }
      &.AI30-1{
        .body.ai30{ visibility: visible; }
      }
      &.astro{
        .body.astro{ visibility: visible; }
      }
    }
    .body{
      left: 0; right: 0; top: 0; bottom: 0;
      position: absolute;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      &.default1{
        background-image: url(../assets/acc/acc-winter-bawah-1.png);
      }
      &.default2{
        background-image: url(../assets/acc/acc-summer-bawah-1.png);
      }
      &.badut{
        background-image: url(../assets/acc/acc-badut-bawah-1.png);
      }
      &.indo{
        background-image: url(../assets/acc/acc-indo-bawah-1.png);
      }
      &.gym{
        background-image: url(../assets/acc/acc-gym-bawah-1.png);
      }
      &.sekolah{
        background-image: url(../assets/acc/acc-sekolah-bawah-1.png);
      }
      &.farmer{
        background-image: url(../assets/acc/acc-petani-bawah-1.png);
      }
      &.lab{
        background-image: url(../assets/acc/acc-lab-bawah-1.png);
      }
      &.gym2{
        background-image: url(../assets/acc/acc-gym2-bawah-1.png);
      }
      &.bodykey{
        background-image: url(../assets/acc/acc-bk-bawah-1.png);
      }
      &.indo2{
        background-image: url(../assets/acc/acc-indo2-1-bawah.png);
      }
      &.paskib{
        background-image: url(../assets/acc/acc-paskib-1-bawah.png);
      }
      &.hero{
        background-image: url(../assets/acc/acc-pahlawan-1-bawah.png);
      }
      &.ai30{
        background-image: url(../assets/acc/acc-AI30-1-bawah.png);
      }
      &.astro{
        background-image: url(../assets/acc/acc-astro-1.png);
      }
    }
  }
  .recording{
    position: absolute;
    z-index: 16;
    left: 50%; bottom: 20px;
    border: red 2px solid;
    color: red;
    font-size: 14px;
    text-transform: uppercase;
    transform: translateX(-50%);
    font-weight: 600;
    border-radius: 5px;
    padding: 4px 10px;
  }
  .actionBtnCnt{
    position: absolute;
    z-index: 16;
    left: 0; bottom: 10px; right: 0;
    display: flex;
    justify-content: center;
    .actionInfo{
      position: absolute;
      left: 50%; top: 14px; bottom: 14px;
      transform: translateX(-50%);
      margin-left: -60px;
      background-color: #cddd00;
      background-color: #b4c200;
      // color: #fff;
      display: flex;
      align-items: center;
      border-radius: 50px 0 0 50px;
      font-weight: 600;
      width: 120px;
      padding-left: 16px;
    }
    .actionBtn{
      box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      width: auto; height: 40px;
      background-color: #cddd00;
      border-radius: 5px;
      cursor: pointer;
      margin: 0 5px;
      position: relative;
      padding: 9px 20px 0;
      box-sizing: border-box;
      white-space: nowrap;
      img{
        float: left;
        height: 18px;
        margin: 0 8px 0 -2px;
      }
      &:hover{
        background-color: #bccb03;
      }
      &.secondary{
        background-color: #fff;
        &:hover{
          background-color: #f5f5f5;
        }
      }
      &.takePicture{
        padding: 0;
        width: 70px; height: 70px;
        border-radius: 50%;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
        &:after{
          content: "";
          position: absolute;
          left: 5px; top: 5px; right: 5px; bottom: 5px;
          border: #000 1px solid;
          border-radius: 50%;
          opacity: .2;
        }
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 2px;
          background-image: url(../assets/camera.png);
          background-size: 32px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .6;
        }
        &.loading{
          cursor: default;
          box-shadow: none;
          &:before{
            background-image: url(../assets/loading.svg);
            background-size: 46px auto;
          }
        }
        &.pictCd{
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 36px;
          &:before{
            display: none;
          }
        }
      }
      &.takeVideo{
        padding: 0;
        width: 64px; height: 64px;
        border-radius: 50%;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
        background-color: #fff;
        transition: all .3s ease;
        &:hover{
          box-shadow: 2px 2px 8px rgba(0, 0, 0, .4);
          background-color: #eee;
        }
        &:after{
          content: "";
          position: absolute;
          left: 4px; top: 4px; right: 4px; bottom: 4px;
          border: #ccc 2px solid;
          background-color: red;
          border-radius: 50%;
        }
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 2px;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .6;
        }
        &.loading{
          cursor: default;
          box-shadow: none;
          &:before{
            background-image: url(../assets/loading.svg);
            background-size: 46px auto;
          }
        }
      }
    }
  }
}

.loadingCnt{
  position: absolute;
  left: 0; top: 0; right: 0; bottom: 0;
  background-color: #fbffc9;
  z-index: 17;
  border-radius: 5px;
  text-align: center;
  opacity: 0;
  transition: all .36s ease;
  &.open{
    opacity: 1;
  }
  .loadingLabel{
    position: absolute;
    top: 50%; transform: translateY(-50%);
    left: 20px; right: 20px;
    img{
      margin: 0 0 20px;
      opacity: .65;
      width: 46px;
    }
    .loader{
      height: 46px;
      margin: 0 0 20px;
      background-image: url(../assets/loading.svg);
      background-size: 46px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  h4{
    margin: 0 0 2px;
    color: #767676;
    font-size: 19px;
  }
  p{
    margin: 0;
    font-size: 15px;
    color: #767676;
  }
}

.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 540px) {
    align-items: flex-start;
  }
  .modalOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
    opacity: 1;
  }
  .modalContent{
    position: absolute;
    background-color: #fbffc9;
    z-index: 2;
    padding: 10px;
    border-radius: 5px;
    margin-top: -20px;
    width: 340px;
    .canvasRealCnt{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      overflow: hidden;
      .canvasReal{
        position: absolute;
        left: 10px; top: 10px;
      }
    }
    .pictBlinker{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      background-color: #fff;
      z-index: 21;
      opacity: .85;
      transition: all .6s ease;
      &.closeed{
        opacity: 0;
      }
    }
    .pictOk{
      position: absolute;
      right: 0; bottom: 0;
      width: 100%; height: 100%;
      box-sizing: border-box;
      padding: 10px;
      background-color: #fbffc9;
      background-color: #444;
      transition: all .76s ease;
      border-radius: 5px;
      z-index: 17;
      transform-origin: right bottom;
      canvas{
        &.canvasFake{
          transform: scaleX(-1);
        }
      }
      &.okur{
        &.pict1Ok{
          transform: scale(.1) translate(-800px, -240px);
        }
        &.pict2Ok{
          transform: scale(.1) translate(-700px, -240px);
        }
        &.pict3Ok{
          transform: scale(.1) translate(-600px, -240px);
        }
        &.pict4Ok{
          transform: scale(.1) translate(-500px, -240px);
        }
      }
    }
    .outro{
      position: absolute;
      z-index: 17;
      left: 10px; top: 10px; right: 10px; bottom: 10px;
      img{
        width: 100%;
      }
      .btnCnt{
        position: absolute;
        left: 16px; right: 16px; bottom: 4px;
        .btn{
          display: block;
          width: 100%;
          text-align: left;
          margin: 0 0 6px;
          padding: 12px 20px;
          padding-left: 60px;
          height: auto;
          position: relative;
          text-transform: none;
          font-weight: 500;
          color: #fff;
          &:before{
            content: "";
            position: absolute;
            left: 16px; top: 0; bottom: 4px;
            width: 30px;
            background-size: 20px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &.download{
            &:before{
              background-image: url(../assets/download-white.png);
            }
          }
          &.share{
            &:before{
              background-image: url(../assets/share-white.png);
            }
          }
        }
      }
    }
    .intro{
      position: absolute;
      z-index: 17;
      border-radius: 5px;
      background-color: #fbffc9;
      background-image: url(../assets/Sedih-Lili-1.png);
      background-size: 160px auto;
      background-position: 120% 100%;
      background-repeat: no-repeat;
      left: 0; top: 0; right: 0; bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0 20px;
      box-sizing: border-box;
      h4{
        margin: 0 0 6px;
        font-size: 24px;
      }
      p{
        margin: 0 0 20px;
        font-size: 15px;
        line-height: 1.2;
        opacity: .75;
      }
      button{
        // background-color: #70be09;
        // background-image: linear-gradient(-30deg, #70be09, #d1ff96);
        // color: #006519;
        background-color: #cddd00;
        color: #444;
        padding: 14px 34px;
        border-radius: 5px;
        border: none;
        border-radius: 50px;
        font-size: 18px;
        font-weight: 600;
        cursor: pointer;
        // box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
        transition: all .3s ease;
        &:hover{
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
        }
      }
    }
    &.finished{
      width: 580px;
      text-align: center;
      padding: 30px 40px;
      background-color: #fff;
      @media (max-width: 680px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 30px 30px 20px;
      }
      .selectorCnt{
        display: flex;
        justify-content: center;
        @media (max-width: 680px) {
          justify-content: space-between;
        }
        .selectorItem{
          padding: 14px 34px 10px;
          border: #fff 1px solid;
          border-radius: 5px;
          transition: all .2s ease;
          position: relative;
          text-align: center;
          color: #444;
          @media (max-width: 680px) {
            padding: 14px 10px 4px;
          }
          &:hover{
            opacity: 1;
            // border-color: #f5f5f5;
            // box-shadow: 2px 2px 2px rgba(0,0,0,.1);
            cursor: pointer;
            background-color: #f5f5f5;
          }
          h4{
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: #006519;
            font-size: 12px;
          }
          img{
            height: 30px;
            margin-bottom: 5px;
          }
        }
      }
      h4{
        margin: 0;
        font-size: 24px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #444;
        font-weight: bold;
        font-size: 18px;
        text-align: center;
      }
      p{
        margin: 0 0 4px;
        font-size: 14px;
        span{
          color: #006519;
          font-weight: bold;
        }
      }
      .loadingCnt{
        text-align: center;
        h4{
          margin: 0 0 2px;
          color: #767676;
          font-size: 19px;
        }
        p{
          margin: 0;
          font-size: 15px;
          color: #767676;
          line-height: 1.1;
        }
      }
      .bgCnt{
        text-align: center;
        height: 220px;
        overflow: hidden;
        background-color: #f5f5f5;
        margin-bottom: 14px;
        background-position: center;
        background-size: 46px auto;
        background-repeat: no-repeat;
        &.loading{
          background-color: #fff;
          background-image: url(../assets/loading.svg);
        }
        img{
          width: 100%;
          max-width: 180px;
        }
      }
      .downloadCnt{
        text-align: center;
        padding-bottom: 10px;
      }
      .download{
        background-color: #8EC642;
        color: #fff;
        padding: 10px 20px;
        box-sizing: border-box;
        border-radius: 3px;
        // box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        display: inline-block;
        text-align: center;
        // font-weight: bold;
        margin-top: 10px;
        padding-left: 48px;
        position: relative;
        &:before{
          position: absolute;
          content: "";
          left: 14px; top: 5px;
          width: 24px; height: 24px;
          background-image: url(../assets/download-o-white.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .shareLink{
        margin: 10px 34px 4px;
        background-color: #f5f5f5;
        border: #ccc 1px solid;
        border-radius: 3px;
        color: #222;
        padding: 10px 12px;
        position: relative;
        padding-right: 80px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // display: none;
        @media (max-width: 680px) {
          margin: 10px 0 4px;
        }
        .copy{
          position: absolute;
          right: 4px; top: 4px;
          font-weight: 600;
          color: #01641a;
          padding: 6px 10px;
          border-radius: 3px;
          cursor: pointer;
          &:hover{
            background-color: #ddd;
          }
        }
      }
    }
    @media (max-width: 768px) {
      margin-top: 60px;
    }
    @media (max-width: 540px) {
      transform: scale(.9);
    }
    .close{
      width: 26px; height: 26px;
      border-radius: 50%;
      position: absolute;
      right: -10px; top: -10px;
      background-color: #ff4c4c;
      background-image: url(../assets/close-white.png);
      background-size: 10px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      z-index: 99;
      &:hover{
        background-color: red;
      }
    }
    .adjustLabel{
      position: absolute;
      right: -140px;
      width: 120px;
      top: 50%; transform: translateY(-50%);
      font-size: 14px;
      color: #fff;
      @media (max-width: 680px) {
        display: none;
      }
    }
  }
}
</style>
